
import {
  defineComponent, onBeforeMount, reactive,
} from 'vue';
import message from 'ant-design-vue/lib/message';
import { useAppBase } from '@/core/composables/AppBase';
import ComunicacaoApi from '@/core/components/UI/ComunicacaoApi.vue';
import IndicadorNumero from '@/core/components/UI/IndicadorNumero.vue';
import Icone from '@/core/components/UI/Icone.vue';
import { IDTODashboardIndicadores } from '@/models/DTO/Dashboard/IDTODashboardIndicadores';
import ServicoDashboard from '@/servicos/ServicoDashboard';
import storeApp from '@/store/storeApp';
import { IDTODashboardForcaVendas, IDTODashboardForcaVendasFiltros } from '@/models/DTO/ForcaVendas/IDTODashboard';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import router from '@/router';
import { EStatusResposta, IResposta } from '@/core/models/IResposta';
import ServicoApp from '@/servicos/ServicoApp';
import { IDTOSincronizarVendedor } from '@/models/DTO/IDTOSincronizarVendedor';
import { ETipoIntegracao } from '@/models/Enumeradores/ETipoIntegracao';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import ServicoPedido from '@/servicos/ServicoPedido';
import SelecionarDataInicialFinal from '@/core/components/UI/SelecionarDataInicialFinal.vue';
import GerenciadorAutenticacao from '@/core/gerenciadores/GerenciadorAutenticacao';

export default defineComponent({
  name: 'Dashboard',
  components: {
    Icone,
    ComunicacaoApi,
    IndicadorNumero,
    SelecionarDataInicialFinal,
  },
  setup() {
    const servicoDashboard = new ServicoDashboard();
    const servicoApp = new ServicoApp();
    const servicoPedido = new ServicoPedido();
    const gerenciadorAutenticacao = new GerenciadorAutenticacao();

    const {
      appBase, apresentarComunicacaoApi, apresentarMensagemSucesso, apresentarMensagemAlerta, ocultarComunicacaoApi,
    } = useAppBase();

    const state = reactive({
      indicadoresCadastros: {} as IDTODashboardIndicadores,
      indicadoresForcaVendas: {} as IDTODashboardForcaVendas,
      filtros: {} as IDTODashboardForcaVendasFiltros,
    });

    function limparDados() {
      state.indicadoresCadastros.produtosAtivos = 0;
      state.indicadoresCadastros.clientesAtivos = 0;
      state.indicadoresCadastros.formasEntregasAtivas = 0;
      state.indicadoresCadastros.formasPagamentosAtivas = 0;
    }

    function limparDadosForcaVendas() {
      state.filtros.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
      state.filtros.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
      state.indicadoresForcaVendas.clientesAtendidos = 0;
      state.indicadoresForcaVendas.totalVendas = 0;
      state.indicadoresForcaVendas.totalVendasDia = 0;
      state.indicadoresForcaVendas.quantidadeVendas = 0;
      state.indicadoresForcaVendas.quantidadeVendasDia = 0;
      state.indicadoresForcaVendas.ticketMedio = 0;
      state.indicadoresForcaVendas.clientesBase = 0;
      state.indicadoresForcaVendas.clientesAtendidos = 0;
    }

    function irParaClientesForcaVendas() {
      router.push({ name: 'ForcaVendasClientes' });
    }

    function irParaPedidosForcaVendas() {
      router.push({ name: 'ForcaVendasPedidos' });
    }

    async function sincronizarDadosVendedor() {
      if (storeApp.state.integracoesErp[0].codigo > 0 && storeApp.state.integracoesErp[0].tipo === ETipoIntegracao.ErpVisualSAEF) {
        const objeto:IDTOSincronizarVendedor = {} as IDTOSincronizarVendedor;
        objeto.codigoIntegracao = storeApp.state.integracoesErp[0].codigo;
        objeto.vendedor = storeApp.state.codigoVendedor;
        objeto.dias = 90;
        appBase.resposta = {} as IResposta;
        apresentarComunicacaoApi('Aguarde por favor... Estamos sincronizando as suas informações.');
        appBase.resposta = await servicoApp.sincronizarDadosVendedor(objeto);
        ocultarComunicacaoApi();
        if (appBase.resposta.status === EStatusResposta.Sucesso) {
          apresentarMensagemSucesso(appBase.resposta.mensagens[0].subMensagens[0]);
        } else {
          apresentarMensagemAlerta(appBase.resposta.mensagens[0].subMensagens[0]);
        }
      }
    }

    async function buscarDashboardForcaVendas() {
      state.filtros.codigoVendedor = storeApp.state.codigoVendedor;
      state.indicadoresForcaVendas = await servicoPedido.dashboardForcaVendas(state.filtros);
    }

    async function deslogar() {
      const retornoAutenticacao = await servicoApp.deslogar();
      if (!retornoAutenticacao.autenticado) {
        gerenciadorAutenticacao.removerDadosAutenticacao();
        router.push({ name: 'Login' });
      } else {
        message.warn(retornoAutenticacao.mensagem);
      }
    }

    onBeforeMount(async () => {
      limparDados();
      limparDadosForcaVendas();
      appBase.carregando = true;
      if (storeApp.state.forcaVendas) {
        await buscarDashboardForcaVendas();
      } else {
        state.indicadoresCadastros = await servicoDashboard.obterIndicadoresDashBoard();
      }

      appBase.carregando = false;
    });

    return {
      appBase,
      state,
      storeApp,
      UtilitarioMascara,
      irParaClientesForcaVendas,
      irParaPedidosForcaVendas,
      sincronizarDadosVendedor,
      buscarDashboardForcaVendas,
      deslogar,
    };
  },
});
